export default "__VITE_ASSET__DgZCDz_r__"